// Tiny UI event bus so distant components can ask the auth modal to open
// (e.g. the home prompt bar for logged-out visitors) without prop drilling.
// Purely a UI concern — no auth logic lives here.
const authListeners = new Set();

export function onOpenAuth(listener) {
  authListeners.add(listener);
  return () => authListeners.delete(listener);
}

export function openAuth() {
  authListeners.forEach(fn => fn());
}
